<template>
    <div v-if="user">
        <report-window
            v-if="ready"
            endpoint="/reports/deploy_history"
            :perPage="500"
            :fields="fields"
            :title="title"
            :headers="headers"
            :current.sync="current"
            :columnClick="columnClick"
            :templates="templates"
            :columnsClasses="columnsClasses"
            :slotsFields="slotsFields"
            :callbacks="callbacks"
            :updateReport="updateReport"
            :allowChart="false"
            :runMounted="true"
        ></report-window>
    </div>
</template>

<script>
import ReportWindow from "@/components/tools/ReportWindow";
import { mapState } from "vuex";
export default {
    name: "deploy-history",
    props: [],
    components: {
        ReportWindow,
    },
    computed:{
        ...mapState({
            user: state => state.main.user,
        }),
    },
    async mounted () {
        await this.fetchCustomers();
        frontTools.setReportValues(this);
        this.fields = Object.assign([], this.fields);
        this.ready = true;
    },
    methods: {
        async fetchCustomers() {
            try {
                let customers = await api.get('/public/api/customers/');
                this.customerOptions = customers.map(c => ({
                    label: c.Name,
                    value: c.Name
                }));
            } catch (err) {
                console.error('Error fetching customers:', err);
            }
        },
    },
    data () {
        let self = this;
        return {
            current: {},
            updateReport: false,
            ready: false,
            customerOptions: [],
            fields: [
                {name: 'FromDate', editor: 'date', label: 'From'},
                {name: 'ToDate', editor: 'date', label: 'To'},
                {name: 'CustomerName', label: 'Customer', editor: 'vue-select', addBlank: true,
                    optionLabels: 'label', options: []},
                {name: 'DeployType', label: 'Deploy Type', editor: 'select', addBlank: true,
                    options: [
                        { label: 'FRONT', value: 'FRONT'},
                        { label: 'BACK', value: 'BACK'},
                    ]
                },
            ],
            title: "Deploy History",
            headers: {
            },
            templates: [
                {name: 'Date', callback: (row) => {
                        if (!row.Date) return '';
                        return moment.utc(row.Date).local().format("DD MMM YYYY HH:mm");
                    }
                },
            ],
            columnClick: {
            },
            slotsFields: [
            ],
            callbacks: {
            },
            columnsClasses: {
            },
        };
    },
    watch: {
        customerOptions(newVal) {
            let customerField = this.fields.find(f => f.name === 'CustomerName');
            if (customerField) {
                customerField.options = newVal;
            }
        }
    },
}
</script>
</script>